<template>
  <q-card class="text-black rounded-borders-4 q-mb-lg" :class="css_class" flat>
    <q-card-section :class="clear ? 'clear': ''">
      <div>
        <div class="flex no-wrap items-center text-bold q-gutter-x-md" v-if="header">
          <q-icon v-if="!no_icon" :name="banner_icon" :color="type" :class="header_class"></q-icon>
          <span :class="`text-${type} ${header_class}`">
            {{ header }}
          </span>
        </div>
        <div class="flex column q-gutter-y-sm q-pt-sm" v-if="lines" :class="`text-${type} ${lines_class}`">
          <div v-for="line in lines">{{ line }}</div>
        </div>
        <div class="q-mt-sm" v-if="buttons">
          <div class="row q-gutter-md">
            <q-btn v-for="btn in buttons" no-caps class="text-100 text-white rounded-borders-10" flat
                   :icon-right="btn.btn_icon" :class="btn.btn_background_color"
                   :label="btn.btn_label" @click="btn.btn_click"></q-btn>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { computed } from "vue";

export default {
  name: "CpNotice",
  props: {
    clear: {
      type: Boolean
    },
    header: {
      type: String
    },
    header_class: {
      type: String,
      default: 'text-125'
    },
    lines: {
      type: Array
    },
    lines_class: {
      type: String,
      default: 'text-100'
    },
    no_icon: {
      type: Boolean
    },
    icon: {
      type: String
    },
    type: {
      type: String,
      enum: [
        'positive',
        'negative',
        'warning',
        'info'
      ],
      required: false
    },
    buttons: {
      type: Array
    }
  },
  setup(props) {
    const banner_icon = computed(({
      get: () => {
        if (!props.no_icon && !props.icon) {
          switch (props.type) {
            case 'negative':
              return 'error_outline';
            case 'positive':
              return 'o_check_circle';
            case 'warning':
              return 'warning';
            case 'info':
              return 'o_campaign';
          }
        }
        else {
          return props.icon;
        }
      }
    }))

    const type_background = computed(() => {
      return `bg-${props.type}`;
    })

    const css_class = computed(() => {
      if (!props.clear) {
        return `order-status-banner-${props.type}`;
      }
    })
    const show_button = computed(() => {
      return props.btn_label;
    })

    return {
      type_background,
      banner_icon,
      css_class,
      show_button
    }
  }
}
</script>

<style lang="scss" scoped>

$types: positive $positive $positive-accent, negative $negative $negative-accent, info $info $info-accent, warning $warning $warning-accent, black $black $black-accent;

@mixin order-status($color, $accent) {
  background-color: $accent;
  border-left: 5px solid $color;
  //border-right: 5px solid $color;
}

@each $type in $types {
  .order-status-banner-#{nth($type, 1)} {
    @include order-status(#{nth($type, 2)}, #{nth($type, 3)})
  }
}

.clear {
  padding-left: 0px;
}

</style>
